import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { backendUnavailableSubscribers } from "../utils/backendUnavailableBus";
import UnderDevelopment from "./UnderDevelopment";

// Wraps the router's <Switch> once, rather than each page individually -
// useAxios reports a 404/501 GET here instead of every page having to wire
// up its own "backend isn't ready" fallback state.
const BackendGate = ({ children }) => {
    const location = useLocation();
    const [brokenPath, setBrokenPath] = useState(null);

    useEffect(() => {
        // a new route starts clean - a previous page's failure shouldn't
        // follow the user to whatever they navigate to next
        setBrokenPath(null);

        const handler = (pathname) => {
            if (pathname === window.location.pathname) setBrokenPath(pathname);
        };
        backendUnavailableSubscribers.add(handler);
        return () => backendUnavailableSubscribers.delete(handler);
    }, [location.pathname]);

    if (brokenPath === location.pathname) return <UnderDevelopment />;
    return children;
};

export default BackendGate;
